import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.scss'

// 恢复用户认证状态
function restoreAuthState() {
  const userInfo = localStorage.getItem('userInfo')
  if (userInfo) {
    try {
      const user = JSON.parse(userInfo)
      if (user.token) {
        // 检查cookie是否存在
        const cookies = document.cookie.split(';')
        const hasToken = cookies.some(cookie => cookie.trim().startsWith('console_cs_token='))
        
        if (!hasToken) {
          // 如果cookie不存在，从localStorage恢复
          document.cookie = `console_cs_token=${user.token}; path=/; max-age=${7 * 24 * 60 * 60}; SameSite=Lax`
          console.log('Cookie已从localStorage恢复: console_cs_token')
        }
      }
    } catch (error) {
      console.error('恢复认证状态失败:', error)
    }
  }
}

// 在应用启动时恢复认证状态
restoreAuthState()

const app = createApp(App)

app.use(router)
app.mount('#app')
